import {
  SET_PURCHASE_PLACES,
  SET_PURCHASE_PLACES_LOADING,
  UNSET_PURCHASE_PLACES_LOADING,
  SET_SERIAL_NUMBER_MANDATORY,
} from '@/context/purchasePlaces/types';

export const setPurchasePlaces = payload => ({
  type: SET_PURCHASE_PLACES,
  payload,
});
export const setPurchasePlacesLoading = () => ({
  type: SET_PURCHASE_PLACES_LOADING,
});
export const unsetPurchasePlacesLoading = () => ({
  type: UNSET_PURCHASE_PLACES_LOADING,
});
export const setSerialNumberMandatory = payload => ({
  type: SET_SERIAL_NUMBER_MANDATORY,
  payload,
});
